module.exports = __webpack_public_path__ + "img/대치동 미용실.a4ce19bf.png";